export default "__VITE_ASSET__BUkyfLUM__"